"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames_1 = require("../../../utilities/classNames");
var form_1 = require("../form");
var formCore_1 = require("../formCore");
var CheckboxInput = /** @class */ (function (_super) {
    tslib_1.__extends(CheckboxInput, _super);
    function CheckboxInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckboxInput.prototype.focus = function () {
        if (this.input) {
            this.input.focus();
        }
    };
    CheckboxInput.prototype.blur = function () {
        if (this.input) {
            this.input.blur();
        }
    };
    CheckboxInput.prototype.render = function () {
        var _this = this;
        var validationMessage = formCore_1.DataValidationMessage.get(this.props);
        var _a = this.props, validationMode = _a.validationMode, labelContent = _a.labelContent, id = _a.id, attrs = tslib_1.__rest(_a, ["validationMode", "labelContent", "id"]);
        var autoId = id || form_1.generateUniqueId(function (u) { return "checkbox_" + u; });
        var classes = classNames_1.ClassHelpers.classNames("armstrong-input", "checkbox", this.props.className, {
            "show-validation": (validationMode !== "none" && validationMessage),
        });
        return (React.createElement("div", { className: classes },
            React.createElement("input", tslib_1.__assign({}, attrs, { ref: function (i) { return _this.input = i; }, id: autoId, type: "checkbox" })),
            React.createElement("label", { htmlFor: autoId }),
            React.createElement("label", { className: "checkbox-label", htmlFor: autoId }, labelContent)));
    };
    CheckboxInput.defaultProps = {
        validationMode: "none",
    };
    return CheckboxInput;
}(React.Component));
exports.CheckboxInput = CheckboxInput;
